/* lua.js generated code undefined */

let DASchemeConfig = require("clover/config/userTag/DASchemeConfig")
// let AIPredictionManager = require("clover/aiPrediction/AIPredictionManager")
// let AIPredictionConst = require("clover/aiPrediction/AIPredictionConst")
let [DAUserDataV2, DATA_KEYS] = unpack(require("clover/gamePlay/DropAdjust/DAUserDataV2"))
const Event = require("cocos/framework/components/event")
let DAManagerV2 = xClass("DAManagerV2", Event)
let DA_EXPIRE_DURATION = 3600 * 24 * 1
let _instance = null
DAManagerV2.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DAManagerV2.new()
    }
    return _instance
}
DAManagerV2.prototype.ctor = function () {
    let self = this
    self._currentSchemeCfg = null
    self._currentMostColor = table([1, "least", 0], [1, "most", 0])
    // self._excludePlans = table()
    // self.qaPlan = 0
    // self.qaScheme = -1
    self._strategyAdjustPlan = {};   //调节干预方案用的对应关系
    self._useDATargetCountV2 = false //是否使用新计数，新干预可以用新计数和老计数，不同计数要用不同的期望数据
    self.load()
}
DAManagerV2.prototype.useV2 = function () {
    let self = this
    return true
}
DAManagerV2.prototype.getCube = function () {
    let self = this
    return self.cubeGroup
}
DAManagerV2.prototype.reset = function () {
    let self = this
    self._expectCountCache = table()
    self._natureDiffCache = table()
    self._updateTimeCache = table()
    // self._expectCountV2Cache = table()
    // self._natureDiffCache = table()
    // self._updateTimeV2Cache = table()
    // self._itemStepExpectV2Cache = table()
    self._strategyAdjustPlan = {};
    self._currentSchemeCfg = null
    self._currentMostColor = table([1, "least", 0], [1, "most", 0])
}
DAManagerV2.prototype.load = function () {
    let self = this
    let data = Localhost.getDropAdjustData()
    self._expectCountCache = data.expectCountCache || table()
    self._natureDiffCache = data.natureDiffCache || table()
    self._updateTimeCache = data.updateTimeCache || table()
    // let data2 = Localhost.getDropAdjustDataV2()
    // self._expectCountV2Cache = data2.expectCountV2Cache || table()
    // self._natureDiffCache = data2.natureDiffV2Cache || table()
    // self._updateTimeV2Cache = data2.updateTimeV2Cache || table()
    // self._itemStepExpectV2Cache = data2.itemStepExpectV2Cache || table()
    // self.loadSchemeCfg()
}
// DAManagerV2.prototype.loadTestTagConfig = function (testTagCfg) {
//     let self = this
//     if (GameSpeedUp.getInstance().isInGame) {
//         return 
//     }
//     self._testTagCfg = testTagCfg
//     Toast.make("【掉落优化Tag】测试标签配置")
// }
// DAManagerV2.prototype.loadTestSchemeConfig = function (testSchemeCfg) {
//     let self = this
//     if (GameSpeedUp.getInstance().isInGame) {
//         return 
//     }
//     self.loadSchemeCfg(testSchemeCfg)
//     Toast.make("【掉落优化Scheme】测试方案配置")
// }
DAManagerV2.prototype.getTestTagCfg = function () {
    let self = this
    return self._testTagCfg || table()
}
// 加载方案配置，并按优先级排序
// DAManagerV2.prototype.loadSchemeCfg = function (testCfg) {
//     let self = this
//     self._schemeCfg = table()
//     let cfg = testCfg || UserTagData.getInstance().DASchemeConfig
//     for (let k in cfg) {
//         let v = cfg[k]
//         if ($null(v)) continue
//         v.dcName = DASchemeConfig[k].dcName
//         table.insert(self._schemeCfg, v)
//     }
//     if (testCfg) {
//         self._testFuuuExpects = testCfg.Scheme_fuuu.testExpects
//     }
//     // 按优先级排序（数字越小，优先级越高，届时优先选择方案）
//     table.sort(self._schemeCfg, function (a, b) {
//         return a.priority < b.priority
//     })
// }
// DAManagerV2.prototype.flushData = function () {
//     let self = this
//     let data = table(
//         [1, "expectCountCache", self._expectCountCache],
//         [1, "natureDiffCache", self._natureDiffCache],
//         [1, "updateTimeCache", self._updateTimeCache]
//     )
//     Localhost.setDropAdjustData(data)
//     let data2 = table(
//         [1, "expectCountV2Cache", self._expectCountV2Cache],
//         [1, "natureDiffV2Cache", self._natureDiffCache],
//         [1, "updateTimeV2Cache", self._updateTimeV2Cache],
//         [1, "itemStepExpectV2Cache", self._itemStepExpectV2Cache]
//     )
//     Localhost.setDropAdjustDataV2(data2)
// }
// 获取指定关卡的目标期望完成数列表
//     {
//         [1] = 1,
//         [2] = 3,
//         [3] = 332,
//         [4] = 444,
//     }
DAManagerV2.prototype.getExpectCountList = function (levelId) {
    let self = this
    // if (self._testFuuuExpects && $len(self._testFuuuExpects) > 0) {
    //     return self._testFuuuExpects
    // }
    // levelId = tostring(levelId)
    // return self._expectCountCache[levelId] || table()
    // UserTagData.getInstance().userLabelData.levelNatureDiff
    return UserManager.getInstance().userLabel.except
}
DAManagerV2.prototype.getExpectCountListV2 = function (levelId) {
    let self = this
    let arr = UserManager.getInstance().userLabel.levelNatureDiff
    let result = table()
    table.each(arr, function(diffRecord){
        if (diffRecord && diffRecord.levelId == levelId) {
            result = string.split( diffRecord.completeExpect, ",")
            table.each(result, function(v, k){
                result[k] = tonumber( v.split(":")[1])
            })
            // result = arr
        }
    })
    return result
}
DAManagerV2.prototype.getItemStepExpectV2 = function (levelId) {
    let self = this
    // levelId = tostring(levelId)

    let arr = UserManager.getInstance().userLabel.levelNatureDiff
    let result = 0
    table.each(arr, function(diffRecord){
        if (diffRecord && diffRecord.levelId == levelId) {
            result = diffRecord.itemStepExpect
        }
    })
    return result
}
// 获取指定关卡的自然难度
// DAManagerV2.prototype.getNatureDiff = function (levelId) {
//     let self = this
//     levelId = tostring(levelId)
//     return self._natureDiffCache[levelId] || 999
// }
// 获取指定关卡及前20关的自然难度
// DAManagerV2.prototype.getNature20Diff = function (levelId) {
//     let self = this
//     // cc.log("【掉落优化】计算20关自然难度")
//     DAManagerGUILogger.getInstance().print("【掉落优化】计算20关自然难度")
//     let s = Math.max(1, tonumber(levelId) - 19)
//     let e = tonumber(levelId)
//     let sum = 0
//     let $var33 = s,$limit34 = e
//     for (let i = $var33; i <= $limit34; i += 1) {
//         let lvId = tostring(i)
//         sum = sum + (self._natureDiffCache[lvId] || 999)
//     }
//     return sum
// }
DAManagerV2.prototype.parseCompleteExpect = function (str) {
    let self = this
    let ret = table()
    let l = string.split(str, ",")
    let $limit41 = $len(l)
    for (let i = 1; i <= $limit41; i += 1) {
        let v = string.split(l[i], ":")
        ret[tonumber(v[1])] = tonumber(v[2])
    }
    // he_log_info("ret length:"..tostring(#ret))
    return ret
}
// 检查缓存的记录中有哪些已经过期了（没有数据也视作过期）
// DAManagerV2.prototype.checkExpire = function (levelId) {
//     let self = this
//     levelId = tostring(levelId)
//     if (self._updateTimeCache[levelId]) {
//         let now = Localhost.timeInSec()
//         return now - self._updateTimeCache[levelId] >= DA_EXPIRE_DURATION
//     } else {
//         return true
//     }
// }
// // 检查缓存的记录中有哪些已经过期了（没有数据也视作过期）
// // 计数V2使用
// DAManagerV2.prototype.checkExpireV2 = function (levelId) {
//     let self = this
//     levelId = tostring(levelId)
//     if (self._updateTimeV2Cache[levelId]) {
//         let now = Localhost.timeInSec()
//         return now - self._updateTimeV2Cache[levelId] >= DA_EXPIRE_DURATION
//     } else {
//         return true
//     }
// }
// 获取目前最需要更新的n个关卡
// DAManagerV2.prototype.getUpdateList = function (maxCount, testTopLevel, testPassedLevel) {
//     let self = this
//     maxCount = maxCount || 40
//     let topLevel = testTopLevel && testTopLevel || UserManager.getInstance().getUserRef().getTopLevelId()
//     let passedLevel = testPassedLevel && testPassedLevel || UserManager.getInstance().getPassedTopLevel()
//     let curId = Math.max(0, passedLevel - Math.floor(maxCount / 2))
//     let levels = table()
//     let count = 1
//     while (count < maxCount && curId <= topLevel) {
//         if (self.checkExpire(curId)) {
//             table.insert(levels, curId)
//             count = count + 1
//         }
//         curId = curId + 1
//     }
//     console.log("getUpdateList levels ",levels)
//     return levels
// }
// 获取目前最需要更新的n个关卡
// 计数V2使用
// DAManagerV2.prototype.getUpdateListV2 = function (maxCount, testTopLevel, testPassedLevel) {
//     let self = this
//     maxCount = maxCount || 40
//     let topLevel = testTopLevel && testTopLevel || UserManager.getInstance().getUserRef().getTopLevelId()
//     let curId = Math.max(0, topLevel - Math.floor(maxCount / 2)) + 1
//     let levels = table()
//     let count = 1
//     while (count < maxCount && curId <= topLevel) {
//         if (self.checkExpireV2(curId)) {
//             table.insert(levels, curId)
//             count = count + 1
//         }
//         curId = curId + 1
//     }
//     console.log("getUpdateList 2 levels ",levels)
//     return levels
// }
// 尝试从服务器更新关卡的自然难度及每步的目标期望完成度
// DAManagerV2.prototype.tryUpdateData = function () {
//     let self = this
//     function onSuccess(evt) {
//         he_log_info("update level diffexpect success!")
//         cc.log("【掉落优化】 update level diffexpect V1 success", evt.data)
//         if (evt.data) {
//             // if __DEBUG and __WIN32 and #evt.data == 0 then
//             //     evt.data = {
//             //         targetCompleteExpectConfig = {}
//             //     }
//             //     local levels = self:getUpdateList()
//             //     for _, v in pairs(levels) do
//             //         table.insert(evt.data.targetCompleteExpectConfig,  {
//             //             levelId = v,
//             //             completeExpect = "1:1,2:3,3:332,4:444",
//             //             natureDiff = math.random() * 100,
//             //         })
//             //     end
//             // end
//             let config = evt.data.targetCompleteExpectConfig
//             for (let _ in config) {
//                 let v = config[_]
//                 if ($null(v)) continue
//                 let levelId = tostring(v.levelId)
//                 self._expectCountCache[levelId] = self.parseCompleteExpect(v.completeExpect)
//                 self._natureDiffCache[levelId] = v.natureDiff
//                 self._updateTimeCache[levelId] = Localhost.timeInSec()
//             }
//             self.flushData()
//         }
//     }
//     function onFail(evt) {
//         he_log_info("update level diffexpect failed:" + evt.data)
//     }
//     function onCancel() {
//         let __VA_ARG = $slice(arguments, 0)
//         he_log_info("update level diffexpect canceled")
//     }
//     let levels = self.getUpdateList()
//     if ($len(levels) > 0) {
//         // dump(levels,"need update list")
//         // debug.debug()
//         let http = GetLevelDiffExpectHttp.new(false)
//         http.addEventListener(Events.kComplete, onSuccess)
//         http.addEventListener(Events.kError, onFail)
//         http.addEventListener(Events.kCancel, onCancel)
//         http.load(levels)
//     }
//     // 需要再请求计数V2的期望数据，后续会根据实验结果只取老的或者新的
//     self.tryUpdateDataV2()
// }
// 尝试从服务器更新关卡的自然难度及每步的目标期望完成度
// 这个是拉取计数V2的期望
// DAManagerV2.prototype.tryUpdateDataV2 = function () {
//     let self = this
//     // cc.log("【掉落优化】 DAManagerV2:tryUpdateDataV2")
//     function onSuccess(evt) {
//         he_log_info("update level diffexpect V2 success!")
//         cc.log("【掉落优化】 update level diffexpect V2 success", evt.data)
//         if (evt.data) {
//             // if __DEBUG and __WIN32 and #evt.data == 0 then
//             //     evt.data = {
//             //         targetCompleteExpectConfig = {}
//             //     }
//             //     local levels = self:getUpdateList()
//             //     for _, v in pairs(levels) do
//             //         table.insert(evt.data.targetCompleteExpectConfig,  {
//             //             levelId = v,
//             //             completeExpect = "1:1,2:3,3:332,4:444",
//             //             natureDiff = math.random() * 100,
//             //         })
//             //     end
//             // end
//             let config = evt.data.targetCompleteExpectConfig
//             for (let _ in config) {
//                 let v = config[_]
//                 if ($null(v)) continue
//                 let levelId = tostring(v.levelId)
//                 self._expectCountV2Cache[levelId] = self.parseCompleteExpect(v.completeExpect)
//                 self._natureDiffCache[levelId] = v.natureDiff
//                 self._updateTimeV2Cache[levelId] = Localhost.timeInSec()
//                 self._itemStepExpectV2Cache[levelId] = v.itemStepExpect || 0
//             }
//             self.flushData()
//         }
//     }
//     function onFail(evt) {
//         he_log_info("update level diffexpect failed:" + evt.data)
//         cc.log("【掉落优化】 update level diffexpect failed:" + evt.data)
//     }
//     function onCancel() {
//         let __VA_ARG = $slice(arguments, 0)
//         he_log_info("update level diffexpect canceled")
//     }
//     let levels = self.getUpdateListV2()
//     if ($len(levels) > 0) {
//         let http = GetLevelDiffExpectHttp.new(false)
//         http.addEventListener(Events.kComplete, onSuccess)
//         http.addEventListener(Events.kError, onFail)
//         http.addEventListener(Events.kCancel, onCancel)
//         http.load(levels, "2")
//     }
// }
DAManagerV2.prototype.startLevel = function (levelId, recoverData) {
    let self = this
    DAManagerGUILogger.getInstance().reset()
    DAManagerGUILogger.getInstance().print("【掉落优化】" + "日志清理V2")
    self._levelId = levelId
    self.hasIntervened = false
    self._currentSchemeCfg = null
    self.fuuuReached = false
    self.generalStrongFuuuReached = false
    self._passiveRefreshCount = 0
    if (recoverData && recoverData.replay && recoverData.replay.passiveRefreshCount) {
        self.setPassiveRefreshCount(recoverData.replay.passiveRefreshCount)
    }
    // AI打关不使用任何干预策略
    // if (__robot || __CNN) {
    //     DAManagerGUILogger.getInstance().print("AI打关不使用任何干预策略")
    //     return 
    // }
    // 只对主线关卡生效
    if (!recoverData){
        let levelType = LevelType.getLevelTypeByLevelId(levelId)
        if (levelType !== GameLevelType.kMainLevel) {
            DAManagerGUILogger.getInstance().print("非主线关不使用任何干预策略")
            return 
        } else {
            // 只对玩家未通关的关卡生效（刷关不生效）
            let passedTopLevel = UserManager.getInstance().getPassedTopLevel()
            if (levelId <= passedTopLevel) {
                DAManagerGUILogger.getInstance().print("刷关不使用任何干预策略")
                return 
            }
        }
    }
    //高手攻略播放，对刷关的攻略不使用任何干预策略
    // if(recoverData && recoverData.replay && recoverData.replay.dropAdjustScheme)
    // {
    //     if (table.serialize(recoverData.replay.dropAdjustScheme) == table.serialize(table()))
    //     {
    //         return 
    //     }
    // }

    self._inLevel = true
    self.chooseScheme(levelId, recoverData)
    self.passTargetCount = -1
}
// 在bonus time之前调用，表示关卡常规阶段结束
DAManagerV2.prototype.endLevel = function () {
}
//刷新连续x把完成度
DAManagerV2.prototype.refreshEndLevelStatus = function (isWin, calculateCompleteRatio) {
    let self = this
    //如果有干预 更新状态
    if (self._inLevel) {
        self.test_para9ForDC = null
        let daUserDataV2 = DAUserDataV2.getInstance()

        if (calculateCompleteRatio){ //需要更新完成度
            daUserDataV2.addCompleteRatio(self.levelId)
        }
        
        daUserDataV2.refreshLockedSchemas(self.levelId, isWin, self.fuuuReached)

        daUserDataV2.refreshCdGroups(self.levelId, isWin, self.fuuuReached)
        daUserDataV2.refreshLockedPlans(self.levelId, isWin)
        // if (isWin){

        // }



        // cc.log("--------------before end level----------------------")
        // cc.log("fuuuReached:" + tostring(self.fuuuReached))
        // cc.log("notReachFuuuNum:" + tostring(daUserDataV2.notReachFuuuNum))
        // cc.log("firstPassToplvlNum:" + tostring(daUserDataV2.firstPassToplvlNum))
        // if (self.fuuuReached) {
        //     daUserDataV2.notReachFuuuNum = 0
        //     DAUserDataV2.getInstance().AddFuuuNum()
        // } else {
        //     daUserDataV2.notReachFuuuNum = daUserDataV2.notReachFuuuNum + 1
        // }
        // if (isWin) {
        //     daUserDataV2.firstPassToplvlNum = daUserDataV2.firstPassToplvlNum + 1
        // }
        // self.checkDALock(isWin)
        daUserDataV2.saveAllData()
        // cc.log("--------------after end level----------------------")
        // cc.log("notReachFuuuNum:" + tostring(daUserDataV2.notReachFuuuNum))
        // cc.log("firstPassToplvlNum:" + tostring(daUserDataV2.firstPassToplvlNum))
    }
    //debug.debug()
    self._inLevel = false
}
//检测各个锁定状态
// DAManagerV2.prototype.checkDALock = function (isWin) {
//     let self = this
//     if (!self.selectedPlan) {
//         return 
//     }
//     cc.log("selected plane")
//     dump(self.selectedPlan)
//     if (self.recoverData) {
//         /* if __WIN32 then
//             return
//         end */
//         let [lockedPlan, lockedPlanTime] = daUserDataV2.getLockedPlan()
//         if (lockedPlan === 0) {
//             return 
//         }
//     }
//     let daUserDataV2 = DAUserDataV2.getInstance()
//     if (!self._currentSchemeCfg) {
//         daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//         return 
//     }
//     if (isWin) {
//         //成功过关无条件清除策略锁定
//         cc.log("level win clear locked scheme")
//         daUserDataV2.clearLockedScheme("关卡胜利")
//         if (self.selectedPlan.test_type === 2) {
//             //fuuu干预策略锁定解除则清除方案锁定
//             daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//             cc.log("level win clear type2 plane id:" + tostring(self.selectedPlan.id))
//         }
//     }
//     let curStrategyDetail = daUserDataV2.getLockedSchemeDetail()
//     cc.log("locked scheme detail:")
//     dump(curStrategyDetail)
//     self.test_para5ForDC = null
//     if (self.selectedPlan.test_type === 1) {
//         //回流干预首次过最高主线关次数大于某个值 清除方案锁定
//         self.test_para9ForDC = "n"
//         if (daUserDataV2.firstPassToplvlNum >= tonumber(self.selectedPlan.test_para9)) {
//             self.test_para9ForDC = "y"
//             daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//         }
//         //清除策略锁定
//         if (self._currentSchemeCfg.id === self.selectedPlan.test_strategy1) {
//             self.test_para5ForDC = "n"
//             if (curStrategyDetail.z >= tonumber(self.selectedPlan.test_para5)) {
//                 self.test_para5ForDC = "y"
//                 daUserDataV2.clearLockedScheme("回流z>p5")
//             } else if (curStrategyDetail.y >= tonumber(self.selectedPlan.test_para4)) {
//                 daUserDataV2.clearLockedScheme("回流y>p4")
//             }
//         } else if (self._currentSchemeCfg.id === self.selectedPlan.test_strategy2) {
//             if (curStrategyDetail.z >= tonumber(self.selectedPlan.test_para8) || curStrategyDetail.y >= tonumber(self.selectedPlan.test_para7)) {
//                 daUserDataV2.clearLockedScheme("回流z>p8 or y>p7")
//             }
//         }
//     } else if (self.selectedPlan.test_type === 2) {
//         if (self._currentSchemeCfg.id === self.selectedPlan.test_strategy1) {
//             if (curStrategyDetail.z >= tonumber(self.selectedPlan.test_para4) || curStrategyDetail.y >= tonumber(self.selectedPlan.test_para3)) {
//                 //daUserDataV2:clearLockedScheme()
//                 //daUserDataV2:clearLockedScheme("fuuu z>p4 or y>p3 ")
//                 //fuuu干预策略锁定解除则清除方案锁定
//                 daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//             }
//         } else if (self._currentSchemeCfg.id === self.selectedPlan.test_strategy2) {
//             if (curStrategyDetail.z >= tonumber(self.selectedPlan.test_para7) || curStrategyDetail.y >= tonumber(self.selectedPlan.test_para6)) {
//                 //daUserDataV2:clearLockedScheme()
//                 //daUserDataV2:clearLockedScheme("fuuu z>p7 or y>p6 ")
//                 //fuuu干预策略锁定解除则清除方案锁定
//                 daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//             }
//         }
//     } else if (self.selectedPlan.test_type === 3) {
//         //难度干预直接清除方案锁定
//         daUserDataV2.enterCdGroup(self.selectedPlan.id, self.selectedPlan.test_cd + Localhost.timeInSec())
//     }
// }
DAManagerV2.prototype.encodeScheme = function () {
    let self = this
    let data = {
        currentSchemeCfg: self._currentSchemeCfg
    }
    return data
}
/*     @desc: 在关卡开始时决定干预方案，这里只是选出了方案，可用的scheme在方案里
        首先检查是否有策略锁定，有的话继续此策略锁定的对应流程
        否则再检查是否有方案锁定，有的话继续此方案锁定的对应流程
        否则在方案中查找不在冷却且满足标签的最高优先级的方案
	--@levelId: 关卡号
	--@recoverData: 闪退续打数据
    @return:
 */
DAManagerV2.prototype.chooseScheme = function (levelId, recoverData, excludePlan) {
    let self = this
    // 闪退续打的直接读取录像数据准备恢复关卡，不需要走策略选择
    cc.log("【掉落优化】 chooseScheme levelId=" + tostring(levelId))
    self.test_para2ForDC = null
    self.test_para3ForDC = null
    self.test_para5ForDC = null
    self.test_para6ForDC = null
    self.test_para9ForDC = null
    self.last_paraForDC = null
    self.finalSchema = -1
    self.finalSchemaTypeForDC = null
    self.lockedPlan = null
    self.difficultyTagForDC = null
    self.levelId = levelId

    if (recoverData && recoverData.replay && recoverData.replay.dropAdjustScheme) {
        if (__WIN32) {
            // 这里只是给QA测试用
            // let difficultyTag = UserTagData.getInstance().getTag(UserTagEnum.PersonalDifficulty, levelId)
        }
        if (table.serialize(recoverData.replay.dropAdjustScheme) == table.serialize(table())){
            self._currentSchemeCfg = null
        }else {
            self._currentSchemeCfg = recoverData.replay.dropAdjustScheme
            // self.setStrategy(self._currentSchemeCfg.id)
            if (self._currentSchemeCfg.id === 6 || self._currentSchemeCfg.id === 7) {
                self._useDATargetCountV2 = true
                // cc.log("【掉落优化】 使用计数V2")
                console.log("掉落replay 使用计数V2 self._currentSchemeCfg", self._currentSchemeCfg)
            }
            // self.startpassTargetCount  = self._currentSchemeCfg._purchasePassTargetCount
        }
        console.log("掉落replay 替换DAManagerV2 dropAdjustScheme _currentSchemeCfg", self._currentSchemeCfg)

        let ps = ""
        if (self._currentSchemeCfg) {
            ps = "掉落优化选择方案（闪退续打）：【" + self._currentSchemeCfg.description + "】"
        } else {
            ps = "没有选到方案（闪退续打）"
        }
        ps = ps + "\n----------------------------------------------"
        DAManagerGUILogger.getInstance().print(ps)
        cc.log(ps)
    } else {
        // if (self.excludePlan) {
        //     // 选方案是被排除的方案记录
        //     table.insert(self._excludePlans, tonumber(excludePlan))
        // }
        self._currentSchemeCfg = null
        // let aiPredictionInstance = AIPredictionManager.getInstance()
        let daUserDataV2 = DAUserDataV2.getInstance()
        // if (daUserDataV2.checkLockedPlanExpire()) {
        //     daUserDataV2.clearLockedScheme("方案过期")
        // }
        // 检查策略锁定
        // let lockedSchema = daUserDataV2.getLockedScheme()
        // let [lockedPlan, lockedPlanTime] = daUserDataV2.getLockedPlan()
        let selectedPlanConfig = null
        daUserDataV2.tryRefreshAllTag(levelId) //根据关卡id刷新难度标签
        let difficultyTag = daUserDataV2.getDifficultyTag()
        self.difficultyTagForDC = difficultyTag
        let active7DayTag = daUserDataV2.getActive7DayTag()
        let active30DayTag = daUserDataV2.getActive30DayTag()
        let paymentTag = daUserDataV2.getPaymentTag()
        let levelTag = UserManager.getInstance().user.topLevelId

        function checkPaymentTag(config) {
            // print("【掉落优化】 checkPaymentTag paymentTag="..paymentTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkPaymentTag paymentTag="..paymentTag.." config="..table.tostring(config))
            for (let k in config) {
                let v = config[k]
                if ($null(v)) continue
                if (paymentTag === tonumber(v)) {
                    return true
                }
            }
            return false
        }
        function checkActive7DayTag(config, planConfig) {
            // print("【掉落优化】 checkActive7DayTag active7DayTag="..active7DayTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkActive7DayTag active7DayTag="..active7DayTag.." config="..table.tostring(config))
            for (let k in config) {
                let v = config[k]
                if ($null(v)) continue
                if (type(v) === "number" && active7DayTag === v) {
                    planConfig.active7DayForDc = v
                    return true
                } else if (type(v) === "table" && active7DayTag >= tonumber(v.s) && active7DayTag <= tonumber(v.e)) {
                    planConfig.active7DayForDc = v.s + "_" + v.e
                    return true
                }
            }
            return false
        }
        function checkActive30DayTag(config, planConfig) {
            // print("【掉落优化】 checkActive30DayTag active30DayTag="..active30DayTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkActive30DayTag active30DayTag="..active30DayTag.." config="..table.tostring(config))
            for (let k in config) {
                let v = config[k]
                if ($null(v)) continue
                if (type(v) === "number" && active30DayTag === v) {
                    planConfig.active30DayForDc = v
                    return true
                } else if (type(v) === "table" && active30DayTag >= tonumber(v.s) && active30DayTag <= tonumber(v.e)) {
                    planConfig.active30DayForDc = v.s + "_" + v.e
                    return true
                }
            }
            return false
        }
        function checkLevelTag(config) {
            // print("【掉落优化】 checkLevelTag levelTag="..levelTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkLevelTag levelTag="..levelTag.." config="..table.tostring(config))
            for (let k in config) {
                let v = config[k]
                if ($null(v)) continue
                if (levelTag >= tonumber(v.s) && levelTag <= tonumber(v.e)) {
                    return true
                }
            }
            return false
        }
        function checkdifficultyTag(config) {
            // print("【掉落优化】 checkdifficultyTag difficultyTag="..difficultyTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkdifficultyTag difficultyTag="..difficultyTag.." config="..table.tostring(config))
            for (let k in config) {
                let v = config[k]
                if ($null(v)) continue
                console.log("difficultyTag", difficultyTag, type(difficultyTag))
                if (difficultyTag === tonumber(v)) {
                    return true
                }
            }
            return false
        }
 //-----------------------------------------------------------------------------------
        //添加超鸟干涉条件
        function checkWinWithNuclearBird(config) {
            if (!config || config.min < 0) {
                return true
            }
            let winWithBirdCount = NuclearBirdManager.getInstance().getWinWithBirdLevelCount()
            if (winWithBirdCount >= config.min && winWithBirdCount <= config.max) {
                return true
            }
            return false
        }
        function checkPreNuclearBird(config) {
            if(config && config.min == -2){
                // 产品新增-2，表示活动只要开着就不满足
                return !NuclearBirdManager.getInstance().isOpen(true)
            }else{
                if (!config || config.min < 0) {
                    return true
                }
                let preCount = NuclearBirdManager.getInstance().getPreActivateLevelCount()
                if (preCount >= config.min && preCount <= config.max) {
                    return true
                }
            }
            return false
        }
        function checkPropConsume(config) {
            if (!config || config.level < 0) {
                return true
            }
            let checkLevelCount = config.level
            if (checkLevelCount > 100) {
                checkLevelCount = 100
            }
            let consumeValue = UserManager.getInstance().getLevelConsume(checkLevelCount)
            if (config.min <= consumeValue && config.max >= consumeValue) {
                return true
            }
            return false
        }
        let avaliablePlans = daUserDataV2.getAvaliablePlans()
        let plans = table()
        let hasPlanMutex = table()
        for (let _ in avaliablePlans) {
            let configs = avaliablePlans[_]
            if ($null(configs)) continue
            for (let k in configs) {
                let v = configs[k]
                if ($null(v)) continue
                // DAManagerGUILogger:getInstance():print("\t\t【掉落优化】 开始检查未处于冷却方案：" .. v.id)
                // if (v.id == "86"){
                //     cc.log("pause")
                // }
                // cc.log("【掉落】 检查方案的 互斥组 支付 七日 30日 关卡 难度tag " + v.id + "---------------")

                if (table.exist(hasPlanMutex, v.test_mutex)){
                    console.log("【掉落】方案" + v.id + "所在互斥组已有可选方案")
                }else if (!checkPaymentTag(v.pay_tag)){
                    console.log("【掉落】方案" + v.id + "支付标签不符合")
                }else if (!checkActive7DayTag(v.active_tag_7days, v)){
                    console.log("【掉落】方案" + v.id + "七日标签不符合")
                }else if (!checkActive30DayTag(v.active_tag_30days, v)){
                    console.log("【掉落】方案" + v.id + "30日标签不符合")
                }else if (!checkLevelTag(v.level_tag)){
                    console.log("【掉落】方案" + v.id + "关卡不符合")
                }else if (!checkdifficultyTag(v.difficulty_tag)){
                    console.log("【掉落】方案" + v.id + "难度标签不符合")
                }else if (!checkWinWithNuclearBird(v.win_range_withbird) ){
                    console.log("【掉落】方案" + v.id + "超鸟激活后标签不符合")
                }else if (!checkPreNuclearBird(v.win_range_prebird)){
                    console.log("【掉落】方案" + v.id + "超鸟激活前标签不符合")
                }else if (!checkPropConsume(v.consume)){
                    console.log("【掉落】方案" + v.id + "道具消耗标签不符合")
                }
                if (!table.exist(hasPlanMutex, v.test_mutex) && checkPaymentTag(v.pay_tag) && checkActive7DayTag(v.active_tag_7days, v) && checkActive30DayTag(v.active_tag_30days, v) && checkLevelTag(v.level_tag) && checkdifficultyTag(v.difficulty_tag) && checkWinWithNuclearBird(v.win_range_withbird) && checkPreNuclearBird(v.win_range_prebird) && checkPropConsume(v.consume)) {
                    cc.log("【掉落优化】 可选方案", v.id)
                    table.insert(hasPlanMutex, v.test_mutex)
                    table.insert(plans, table.clone(v))
                }
            }
        }
        // for (let k in plans) {
        //     let v = plans[k]
        //     if ($null(v)) continue
        //     // print("\t\t【掉落优化】 可选方案：", v.id)    DAManagerGUILogger:getInstance():print("\t\t【掉落优化】 可选方案：" .. tostring(v.id))
        // }
        // 4. 取出优先级最高的那个方案
        // cc.log("\t\t【掉落优化】 开始选取最高优先级方案")
        DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 开始选取最高优先级方案")
        let pirority = -1
        let id = -1
        for (let i = 1, v = plans[1]; v; i++, v = plans[i]) {
            // cc.log("\t\t【掉落优化】 方案：" + tostring(v.id) + " 优先级：" + tostring(v.test_priority))
            DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 方案：" + tostring(v.id) + " 优先级：" + tostring(v.test_priority))
            if (v.test_priority > pirority || (v.test_priority === pirority && tonumber(v.id) < id)) {
                pirority = v.test_priority
                id = tonumber(v.id)
                selectedPlanConfig = v
                // cc.log("\t\t【掉落优化】 暂时选中方案：" + tostring(v.id))
                DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 暂时选中方案：" + tostring(v.id))
            }
        }
        // selectedPlanConfig = plans[1] //测试，先选首个方案
                // cc.log("\t\t【掉落优化】 暂时选中方案：" + tostring(v.id))
        // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 暂时选中方案：" + tostring(v.id))
        // }
        // 检查主线关连胜
        function checkTopLevelStreak(x) {
            // return tonumber(passToplvlNum) >= tonumber(x)
            let topLevelStreak = UserManager.getInstance().getUserExtendRef().getTopLevelStreak()
            console.log("【掉落优化】 玩家当前连胜:", topLevelStreak, " 比较参数:", x, " 比较结果:", tonumber(topLevelStreak) >= tonumber(x))
            return tonumber(topLevelStreak) >= tonumber(x)
        }

        function checkCompleteRatio(levelId, test_para6) {
            
            let x =  tonumber( test_para6.split(',')[0])
            let y =  tonumber( test_para6.split(',')[1])
            let completeRatios = daUserDataV2.getCompleteRatios(levelId)
            
            let length = $len(completeRatios)
            let reachNum = 0
            for (let i = length ; i > 0 ; i--){
                if (completeRatios[i] > y){
                    console.log("【掉落优化】 玩家本关完成度:", completeRatios, " 连续", x, "把完成度<=",y, " 比较结果：", false)
                    return false
                }
                reachNum += 1
                if (reachNum >= x){
                    console.log("【掉落优化】 玩家本关完成度:", completeRatios, " 连续", x, "把完成度<=",y, " 比较结果：", true)
                    return true
                }
            }
            console.log("【掉落优化】 玩家本关完成度:", completeRatios, " 连续", x, "把完成度<=",y, " 比较结果：", false)
            return false
            // return true
            // print("【掉落优化】 checkdifficultyTag difficultyTag="..difficultyTag.." config="..table.tostring(config))
            // DAManagerGUILogger:getInstance():print("【掉落优化】 checkdifficultyTag difficultyTag="..difficultyTag.." config="..table.tostring(config))
            // for (let k in config) {
            //     let v = config[k]
            //     if ($null(v)) continue
            //     console.log("difficultyTag", difficultyTag, type(difficultyTag))
            //     if (difficultyTag === tonumber(v)) {
            //         return true
            //     }
            // }
            // return false
        }
        //3.方案所在冷却组中有无策略锁定状态(一些dc数据要重置)

        if (selectedPlanConfig) {
            cc.log("\t\t【掉落优化】 预选中方案：" + tostring(selectedPlanConfig.id))
            if (selectedPlanConfig.active7DayForDc && selectedPlanConfig.active30DayForDc) {
                DCAssist.dc4DAV2Active(selectedPlanConfig.active7DayForDc, selectedPlanConfig.active30DayForDc)
            }
            let lockedSchema = daUserDataV2.checkLockedSchema(selectedPlanConfig);
            if (lockedSchema[0] != null){
                //有锁定策略
                [self.finalSchema, self.finalSchemaTypeForDC] = lockedSchema
            }else {
                let lockedPlan = daUserDataV2.checkLockedPlan(selectedPlanConfig)
                if (!lockedPlan){
                    // self.selectedPlanConfig = selectedPlanConfig
                    // self.chooseStrategy()
                    if (selectedPlanConfig.test_type != 3 ) {
                        self.lockedPlan = daUserDataV2.addLockedPlan(selectedPlanConfig) //增加锁定方案
                    }else {
                        console.log("【掉落优化】 开启难度降低策略test_strategy1");
                        [self.finalSchema, self.finalSchemaTypeForDC] = [selectedPlanConfig.test_strategy1, selectedPlanConfig.test_type]
                        daUserDataV2.addCdGroup(selectedPlanConfig.cd_group, selectedPlanConfig.id)
                    }
                    
                    
                }else{
                    //有锁定方案
                    self.lockedPlan = lockedPlan
                }
            }


            if (self.lockedPlan){
                let id = self.lockedPlan.planId
                let lockedPlannConfig = daUserDataV2.getPlanConfig(id)
                
                console.log("【掉落】 获取指定方案id的配置", id, lockedPlannConfig)

                if (lockedPlannConfig.test_type == 1){
                    //回流用户干预从方案锁定开始

                    if (daUserDataV2.checkPassTopLevelNum(self.lockedPlan.passToplvlNum, lockedPlannConfig.test_para2, self.lockedPlan.planId)){
                        self.test_para2ForDC = 'y'
                        if ( checkTopLevelStreak(lockedPlannConfig.test_para3)){
                            self.test_para3ForDC = 'y'
                            self.last_paraForDC = "test_para3";
                            [self.finalSchema, self.finalSchemaTypeForDC] = daUserDataV2.lockSchema("test_strategy1", lockedPlannConfig, levelId, "test_para4", "test_para5") //增加锁定策略
                        }else if (checkCompleteRatio(levelId, lockedPlannConfig.test_para6)){
                            self.test_para6ForDC = 'y'
                            self.test_para3ForDC = 'n'
                            self.last_paraForDC = "test_para6";
                            [self.finalSchema, self.finalSchemaTypeForDC] = daUserDataV2.lockSchema("test_strategy2", lockedPlannConfig, levelId, "test_para7", "test_para8"); //增加锁定策略
                        }else if (daUserDataV2.checkPassTopLevelNum(self.lockedPlan.passToplvlNum, lockedPlannConfig.test_para9, self.lockedPlan.planId)){
                            self.test_para9ForDC = 'y'
                            self.test_para6ForDC = 'n'
                            self.test_para3ForDC = 'n'
                            console.log("【掉落优化】 理论上关末应该已经判断过关次数解锁策略")
                            self.lockedPlan = daUserDataV2.unlockLockedPlan(self.lockedPlan, lockedPlannConfig, "passToplvlNum", self.lockedPlan.passToplvlNum)
                        }else {
                            self.test_para9ForDC = 'n'
                            self.test_para6ForDC = 'n'
                            self.test_para3ForDC = 'n'
                            console.log("【掉落优化】 开启难度降低策略test_strategy3");
                            [self.finalSchema, self.finalSchemaTypeForDC] = [lockedPlannConfig.test_strategy3, lockedPlannConfig.test_type]
                        }
                    }else {
                        self.test_para2ForDC = 'n'
                        console.log("【掉落优化】 开启难度降低策略test_strategy3");
                        [self.finalSchema, self.finalSchemaTypeForDC] = [lockedPlannConfig.test_strategy3, lockedPlannConfig.test_type]
                    }

                }else if (lockedPlannConfig.test_type == 2){
                    //fuuu用户干预从方案锁定开始
                    if ( checkTopLevelStreak(lockedPlannConfig.test_para2)){
                        self.test_para2ForDC = 'y'
                        self.last_paraForDC = "test_para2";
                        [self.finalSchema, self.finalSchemaTypeForDC] = daUserDataV2.lockSchema("test_strategy1", lockedPlannConfig, levelId, "test_para3", "test_para4") //增加锁定方案
                    }else if (checkCompleteRatio(levelId, lockedPlannConfig.test_para5)){
                        self.test_para5ForDC = 'y'
                        self.test_para2ForDC = 'n'
                        self.last_paraForDC = "test_para5";
                        [self.finalSchema, self.finalSchemaTypeForDC] = daUserDataV2.lockSchema("test_strategy2", lockedPlannConfig, levelId, "test_para6", "test_para7") //增加锁定方案
                    }else {
                        self.test_para5ForDC = 'n'
                        self.test_para2ForDC = 'n'
                    }


                }else {
                    console.log("【掉落优化】 error锁定方案类型错误")
                }
           

            // if (daUserDataV2.firstPassToplvlNum >= tonumber(lockedPlannConfig.test_para2)) {
            //     self.test_para2ForDC = "y"
            //     if (UserManager.getInstance().getOneLife().buffId >= tonumber(lockedPlannConfig.test_para3)) {
            //         self.test_para3ForDC = "y"
            //         self.step_idForDc = "test_para3"
            //         curStrategy = lockedPlannConfig.test_strategy1
            //         // cc.log("\t\t【掉落优化】 选择test_strategy1")
            //         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy1")
            //     } else if (daUserDataV2.notReachFuuuNum >= tonumber(lockedPlannConfig.test_para6)) {
            //         self.test_para6ForDC = "y"
            //         self.step_idForDc = "test_para6"
            //         curStrategy = lockedPlannConfig.test_strategy2
            //         // cc.log("\t\t【掉落优化】 选择test_strategy2")
            //         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy2")
            //     } else if (daUserDataV2.firstPassToplvlNum < tonumber(lockedPlannConfig.test_para9)) {
            //         self.test_para9ForDC = "y"
            //         curStrategy = lockedPlannConfig.test_strategy3
            //         // cc.log("\t\t【掉落优化】 选择test_strategy3")
            //         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy3")
            //     }
            // } else {
            //     //TODO:确认下有锁定方案时候，selectedPlane值是否就是锁定方案
            //     curStrategy = lockedPlannConfig.test_strategy3
            // }
            // //锁定策略
            // daUserDataV2.setData("lockedSchema", curStrategy)
            // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】锁定策略：" + tostring(curStrategy))
            // daUserDataV2.saveAllData()





            }
        
            // if (selectedPlan) {
            //     let ps = "\t\t【掉落优化】 掉落优化选择方案：" + self.selectedPlan.id + "\n\t\t策略组合：" + table.tostring(self.schemes)
            //     ps = ps + "\n----------------------------------------------"
            //     cc.log(ps)
            //     DAManagerGUILogger.getInstance().print(ps)
            // } else {
            //     let ps = "\t\t【掉落优化】 掉落优化策略组合：" + table.tostring(self.schemes)
            //     ps = ps + "\n----------------------------------------------"
            //     cc.log(ps)
            //     DAManagerGUILogger.getInstance().print(ps)
            // }
        } 
        
        if (self.finalSchema >= 0){
            // console.log("【掉落优化】最终选择方案", self.finalSchema)
            self.setStrategy(self.finalSchema)
        }else {
            let ps = "\t\t【掉落优化】 最终没有选到策略"
            // cc.log(ps)
            DAManagerGUILogger.getInstance().print(ps)
        }
        daUserDataV2.saveAllData()
        
        
        // if (self.selectedPlan) {


        //     // cc.log("\t\t【掉落优化】 选中方案：" + tostring(selectedPlan.id))
        //     // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选中方案：" , selectedPlan)
        //     cc.log("\t\t【掉落优化】 无锁定，选中方案：" , selectedPlan.id, selectedPlan)
        //     if (selectedPlan.active7DayForDc && selectedPlan.active30DayForDc) {
        //         // DCAssist.dc4DAV2Active(selectedPlan.active7DayForDc, selectedPlan.active30DayForDc)
        //     }
        //     // self.selectedPlan = selectedPlan
        //     self.schemes = table(
        //         [1, "test_strategy1", selectedPlan.test_strategy1],
        //         [1, "test_strategy2", selectedPlan.test_strategy2],
        //         [1, "test_strategy3", selectedPlan.test_strategy3]
        //     )
        // }
        // if (self.qaScheme >= 0) {
        //     // cc.log("【掉落优化】 测试指定策略：" + tostring(self.qaScheme))
        //     DAManagerGUILogger.getInstance().print("【掉落优化】 测试指定策略：" + tostring(self.qaScheme))
        //     daUserDataV2.AddDANum()
        //     self.setStrategy(self.qaScheme)
        // } else {
            //选择策略
            // self.chooseStrategy()
        // }
        // 5. 打印方案信息
        // cc.log("【掉落优化】 开始---------------------------------------------------------------------------")
        // if (lockedSchema !== -1) {
        //     // cc.log("\t\t【掉落优化】 锁定策略：" + tostring(lockedSchema))
        //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 锁定策略：" + tostring(lockedSchema))
        // }
        // if (lockedPlan !== 0) {
        //     // cc.log("\t\t【掉落优化】 锁定方案：" + tostring(lockedPlan))
        //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 锁定方案：" + tostring(lockedPlan))
        //     // cc.log("\t\t【掉落优化】 锁定方案生效时间：" + os.date("%Y/%m/%d %H:%M:%S", lockedPlanTime))
        //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】锁定方案生效时间：" + os.date("%Y/%m/%d %H:%M:%S", lockedPlanTime))
        // }
        // if (self._testTagCfg) {
        //     // cc.log("【掉落优化】 正在使用【测试配置】")
        //     DAManagerGUILogger.getInstance().print("【掉落优化】 正在使用【测试配置】")
        // }
        // // cc.log("\t\t【掉落优化】 个人难度标签：" + difficultyTag)
        // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 个人难度标签：" + difficultyTag)
        // // cc.log("\t\t【掉落优化】 7天活跃标签：" + active7DayTag)
        // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 7天活跃标签：" + active7DayTag)
        // // cc.log("\t\t【掉落优化】 30天活跃标签：" + active30DayTag)
        // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 30天活跃标签：" + active30DayTag)
        // // cc.log("\t\t【掉落优化】 付费标签：" + paymentTag)
        // DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 付费标签：" + paymentTag)
        // if (self.schemes) {
        //     if (selectedPlan) {
        //         let ps = "\t\t【掉落优化】 掉落优化选择方案：" + self.selectedPlan.id + "\n\t\t策略组合：" + table.tostring(self.schemes)
        //         ps = ps + "\n----------------------------------------------"
        //         cc.log(ps)
        //         DAManagerGUILogger.getInstance().print(ps)
        //     } else {
        //         let ps = "\t\t【掉落优化】 掉落优化策略组合：" + table.tostring(self.schemes)
        //         ps = ps + "\n----------------------------------------------"
        //         cc.log(ps)
        //         DAManagerGUILogger.getInstance().print(ps)
        //     }
        // } else {
        //     let ps = "\t\t【掉落优化】 没有选到方案"
        //     ps = ps + "\n----------------------------------------------"
        //     cc.log(ps)
        //     DAManagerGUILogger.getInstance().print(ps)
        // }
        // cc.log("【掉落优化】 结束---------------------------------------------------------------------------")
    }
    // 准备掉落口统计
    self.resetDropStats()
}
DAManagerV2.prototype.getCurrentSchemeCfg = function () {
    let self = this
    if (self._currentSchemeCfg){
        self._currentSchemeCfg._purchasePassTargetCount = DATargetCounterV2.getInstance().getPurchasePassTargetCount()
    }
    console.log("掉落replay 选中的currentschemecfg", self._currentSchemeCfg)
    return self._currentSchemeCfg
}
// 重置掉落口颜色统计
DAManagerV2.prototype.resetDropStats = function () {
    let self = this
    DAManagerGUILogger.getInstance().print("重置掉落口颜色统计")
    self._dropStats = table([1, "single", table()], [1, "global", table()])
    let $var132 = GameColor.kBlue,$limit133 = GameColor.kYellow
    for (let i = $var132; i <= $limit133; i += 1) {
        self._dropStats.global[i] = table([1, "m", 0], [1, "n", 0])
    }
}
//干预策略选择
// DAManagerV2.prototype.chooseStrategy = function () {
//     let self = this
//     if (!self.selectedPlan) {
//         return 
//     }
//     // self.selectedPlan.test_type = 1
//     //1.回流 2.fuuu 3.难度调整
//     if (self.selectedPlan.test_type === 1) {
//         self.chooseBackflowStrategy()
//     } else if (self.selectedPlan.test_type === 2) {
//         self.chooseFuuuStrategy()
//     } else if (self.selectedPlan.test_type === 3) {
//         self.chooseDifficultyStrategy()
//     }
// }
//回流干预策略
// DAManagerV2.prototype.chooseBackflowStrategy = function () {
//     let self = this
//     // cc.log("【掉落优化】进入选择回流干预")
//     DAManagerGUILogger.getInstance().print("【掉落优化】进入选择回流干预")
//     let daUserDataV2 = DAUserDataV2.getInstance()
//     daUserDataV2.addLockedPlan(self.selectedPlan) //增加锁定方案




//     let curStrategy = daUserDataV2.getLockedScheme()
//     let curStrategyDetail = daUserDataV2.getLockedSchemeDetail()
//     let [lockedPlan, lockedPlanTime] = daUserDataV2.getLockedPlan()
//     if (curStrategy === -1) {
//         //重置锁定策略的状态（目前版本仅为fuuu成功次数和干预次数）
//         daUserDataV2.clearLockedScheme("回流无锁定清除重新锁定")
//         if (lockedPlan === 0) {
//             cc.log("【掉落优化】锁定方案：" + tostring(self.selectedPlan.id))
//             DAManagerGUILogger.getInstance().print("【掉落优化】锁定方案：" + tostring(self.selectedPlan.id))
//             daUserDataV2.setData("lockedPlan", self.selectedPlan.id)
//             daUserDataV2.setData("lockedPlanTime", Localhost.timeInSec())
//             daUserDataV2.firstPassToplvlNum = 0
//             daUserDataV2.saveAllData()
//         }
//         //挑选策略
//         //本次方案锁定状态中首次通过最高主线关次数
//         self.test_para2ForDC = "n"
//         self.test_para3ForDC = "n"
//         self.test_para6ForDC = "n"
//         self.test_para9ForDC = "n"
//         self.step_idForDc = null
//         // cc.log("\t\t【掉落优化】 首次通过最高关次数：" + tostring(daUserDataV2.firstPassToplvlNum))
//         // cc.log("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//         // cc.log("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 首次通过最高关次数：" + tostring(daUserDataV2.firstPassToplvlNum))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//         if (daUserDataV2.firstPassToplvlNum >= tonumber(self.selectedPlan.test_para2)) {
//             self.test_para2ForDC = "y"
//             if (UserManager.getInstance().getOneLife().buffId >= tonumber(self.selectedPlan.test_para3)) {
//                 self.test_para3ForDC = "y"
//                 self.step_idForDc = "test_para3"
//                 curStrategy = self.selectedPlan.test_strategy1
//                 // cc.log("\t\t【掉落优化】 选择test_strategy1")
//                 DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy1")
//             } else if (daUserDataV2.notReachFuuuNum >= tonumber(self.selectedPlan.test_para6)) {
//                 self.test_para6ForDC = "y"
//                 self.step_idForDc = "test_para6"
//                 curStrategy = self.selectedPlan.test_strategy2
//                 // cc.log("\t\t【掉落优化】 选择test_strategy2")
//                 DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy2")
//             } else if (daUserDataV2.firstPassToplvlNum < tonumber(self.selectedPlan.test_para9)) {
//                 self.test_para9ForDC = "y"
//                 curStrategy = self.selectedPlan.test_strategy3
//                 // cc.log("\t\t【掉落优化】 选择test_strategy3")
//                 DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy3")
//             }
//         } else {
//             //TODO:确认下有锁定方案时候，selectedPlane值是否就是锁定方案
//             curStrategy = self.selectedPlan.test_strategy3
//         }
//         //锁定策略
//         daUserDataV2.setData("lockedSchema", curStrategy)
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】锁定策略：" + tostring(curStrategy))
//         daUserDataV2.saveAllData()
//     } else {
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 首次通过最高关次数：" + tostring(daUserDataV2.firstPassToplvlNum))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//     }
//     daUserDataV2.AddDANum()
//     self.setStrategy(curStrategy)
// }
// 检查方案id是否在被排除的方案里
// DAManagerV2.prototype.checkExcludePlans = function (planId) {
//     let self = this
//     for (let k in self._excludePlans) {
//         let v = self._excludePlans[k]
//         if ($null(v)) continue
//         if (planId === v) {
//             return true
//         }
//     }
//     return false
// }
//fuuu策略
// DAManagerV2.prototype.chooseFuuuStrategy = function () {
//     let self = this
//     cc.log("【掉落优化】进入选择fuuu干预")
//     DAManagerGUILogger.getInstance().print("【掉落优化】进入选择fuuu干预")
//     let daUserDataV2 = DAUserDataV2.getInstance()
//     // let curStrategy = daUserDataV2.getLockedScheme()
//     // let curStrategyDetail = daUserDataV2.getLockedSchemeDetail()
//     // let [lockedPlan, lockedPlanTime] = daUserDataV2.getLockedPlan()
//     // if (curStrategy === -1) {
//         let needSave
//         // daUserDataV2.clearLockedScheme("无fuuu锁定清除重锁定")
//         // if (lockedPlan === 0) {
//             cc.log("【掉落优化】锁定方案：" + tostring(self.selectedPlan.id))
//             DAManagerGUILogger.getInstance().print("【掉落优化】锁定方案：" + tostring(self.selectedPlan.id))
//             // daUserDataV2.setData("lockedPlan", self.selectedPlan.id)
//             // daUserDataV2.setData("lockedPlanTime", Localhost.timeInSec())
//             daUserDataV2.setLockedPlan(planid, expiredTime, cdgroup)
//             daUserDataV2.firstPassToplvlNum = 0
//             needSave = true
//         // }
//         self.test_para2ForDC = "n"
//         self.test_para5ForDC = "n"
//         self.step_idForDc = null
//         // cc.log("\t\t【掉落优化】 飞空艇等级：" + tostring(UserManager.getInstance().getOneLife().buffId))
//         // cc.log("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//         // cc.log("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 飞空艇等级：" + tostring(UserManager.getInstance().getOneLife().buffId))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//         DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//         if (UserManager.getInstance().getOneLife().buffId >= tonumber(self.selectedPlan.test_para2)) {
//             // 飞空艇等级>=test_strategy1
//             self.test_para2ForDC = "y"
//             self.step_idForDc = "test_para2"
//             curStrategy = self.selectedPlan.test_strategy1
//             daUserDataV2.setData("lockedSchema", curStrategy)
//             DAManagerGUILogger.getInstance().print("\t\t【掉落优化】锁定策略：" + tostring(curStrategy))
//             needSave = true
//             // cc.log("\t\t【掉落优化】 选择test_strategy1")
//             DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy1")
//         } else if (daUserDataV2.notReachFuuuNum >= tonumber(self.selectedPlan.test_para5)) {
//             // 玩家连续test_para4把未达成fuuu状态
//             self.test_para5ForDC = "y"
//             self.step_idForDc = "test_para5"
//             curStrategy = self.selectedPlan.test_strategy2
//             daUserDataV2.setData("lockedSchema", curStrategy)
//             DAManagerGUILogger.getInstance().print("\t\t【掉落优化】锁定策略：" + tostring(curStrategy))
//             needSave = true
//             // cc.log("\t\t【掉落优化】 选择test_strategy2")
//             DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 选择test_strategy2")
//         } else {
//             // 无视发生
//         }
//         if (needSave) {
//             daUserDataV2.saveAllData()
//         }
//     // } else {
//     //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 飞空艇等级：" + tostring(UserManager.getInstance().getOneLife().buffId))
//     //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 连续未达成fuuu次数：" + tostring(daUserDataV2.notReachFuuuNum))
//     //     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】 干预次数：" + tostring(curStrategyDetail.z))
//     // }
//     daUserDataV2.AddDANum()
//     self.setStrategy(curStrategy)
// }
//难度调整策略
// DAManagerV2.prototype.chooseDifficultyStrategy = function () {
//     let self = this
//     cc.log("【掉落优化】进入选择难度干预")
//     DAManagerGUILogger.getInstance().print("【掉落优化】进入选择难度干预")
//     self.setStrategy(self.selectedPlan.test_strategy1)
// }
//设置scheme
DAManagerV2.prototype.setStrategy = function (strategyId) {
    let self = this
    strategyId = self.checkAdjustStrategy(strategyId);
    // cc.log("【掉落优化】 掉落优化选择策略：" + table.tostring(strategyId))
    DAManagerGUILogger.getInstance().print("【掉落优化】 掉落优化最终选择策略：" + table.tostring(strategyId))
    if (strategyId === 6 || strategyId === 7 || strategyId === 8 || strategyId === 9) {
        self._useDATargetCountV2 = true
        // cc.log("【掉落优化】 使用计数V2")
        DAManagerGUILogger.getInstance().print("【掉落优化】 使用计数V2")
    }
    for (let k in DASchemeConfig) {
        let v = DASchemeConfig[k]
        if ($null(v)) continue
        if (v.id === strategyId) {
            self._currentSchemeCfg = v
            // self.strategyId = strategyId
            return 
        }
    }
    // cc.log("error strateyid:" + tostring(strategyId))
    DAManagerGUILogger.getInstance().print("error strateyid:" + tostring(strategyId))
}
DAManagerV2.prototype.isBalanceScheme = function () {
    let self = this
    if (self._currentSchemeCfg && self._currentSchemeCfg.id === 9) {
        return true
    }
    return false
}
DAManagerV2.prototype.isNegativeScheme = function () {
    let self = this
    if (self._currentSchemeCfg && self._currentSchemeCfg.id === 8) {
        return true
    }
    return false
}
// 尝试进行干预
DAManagerV2.prototype.tryInterveneAnimal = function (mainLogic, r, c, preColor) {
    let self = this
    if (!self._inLevel || preColor === self._currentMostColor.most || preColor === self._currentMostColor.least) {
        // 防止出现同色3连
        let correctColor = ProductItemLogic.checkSameProductColor(mainLogic, r, c, preColor, true)
        return correctColor
    }
    // if (__robot || __CNN) {
    //     Toast.make("机器人不能进行掉落干预！修了这bug！", 30)
    // }
    let resultColor = preColor
    let probabilityPass = false
    let balanceSchema = 0
    let isNegative = false
    if (self._currentSchemeCfg && (self._currentMostColor.most > 0 || self._currentMostColor.least > 0)) {
        let probability = 1
        if (self.isBalanceScheme()) {
            //夹板负向
            if (self._currentMostColor.least > 0) {
                probability = self._currentSchemeCfg.negative.probability
                balanceSchema = 2
            } else if (self._currentMostColor.most > 0) {
                probability = self._currentSchemeCfg.negative.probability
                balanceSchema = 1
            }
        } else if (self.isNegativeScheme()) {
            isNegative = true
            probability = self._currentSchemeCfg.probability
        } else {
            probability = self._currentSchemeCfg.probability
        }
        if (mainLogic.randomValue(1, 100) < probability * 100) {
            probabilityPass = true
        }
    }
    if (probabilityPass) {
        // 单掉落口限制
        let singlePass = false
        let key = r + "_" + c
        if (!self._dropStats.single[key]) {
            self._dropStats.single[key] = table()
            let $var162 = GameColor.kBlue,$limit163 = GameColor.kYellow
            for (let i = $var162; i <= $limit163; i += 1) {
                self._dropStats.single[key][i] = table([1, "m", 0], [1, "n", 0])
            }
        }
        let singleData = self._dropStats.single[key][self._currentMostColor.most]
        if (isNegative) {
            singleData = self._dropStats.single[key][self._currentMostColor.least]
        }
        let tmpDropPort = self._currentSchemeCfg.dropPort
        if (balanceSchema === 1) {
            tmpDropPort = self._currentSchemeCfg.positive.dropPort
        } else if (balanceSchema === 2) {
            tmpDropPort = self._currentSchemeCfg.negative.dropPort
            singleData = self._dropStats.single[key][self._currentMostColor.least]
        }

        singleData.m = singleData.m + 1
       if (singleData.m > tmpDropPort.single.m) {
            singleData.m = 0
            singleData.n = 0
        }
        let singleCount = singleData.n + 1
        if (singleCount <= tmpDropPort.single.n) {
            singlePass = true
        }
        // 全局限制
        let globalPass = false
        let globalData = self._dropStats.global[self._currentMostColor.most]
        if (balanceSchema === 2 || isNegative) {
            globalData = self._dropStats.global[self._currentMostColor.least]
        }
        globalData.m = globalData.m + 1
        if (globalData.m > tmpDropPort.global.m) {
            globalData.m = 0
            globalData.n = 0
        }
        let globalCount = globalData.n + 1
        if (globalCount <= tmpDropPort.global.n) {
            globalPass = true
        }
        if (__WIN32) {
            let ps = "【掉落优化】singleCount: " + singleCount + ", globalCount: " + globalCount
            console.log(ps)
        }
        if ((singlePass && globalPass) || (preColor === self._currentMostColor.most || preColor === self._currentMostColor.least)) {
            singleData.n = singleCount
            globalData.n = globalCount
            resultColor = self._currentMostColor.most
            if (self._currentMostColor.least > 0) {
                resultColor = self._currentMostColor.least
            }
            self.hasIntervened = true
            let ps = "【掉落优化】干预掉落：(" + r + ", " + c + ") Color[" + preColor + "] -> Color[" + resultColor + "]"
            cc.log(ps)
            if (self._currentMostColor.most > 0 && self._currentMostColor.least > 0) {
                let ps = "【掉落优化】干预掉落 出问题了，最大颜色 最小颜色同时存在"
                cc.log(ps)
            }
        }
    }
    // 防止出现同色3连
    let correctColor = ProductItemLogic.checkSameProductColor(mainLogic, r, c, resultColor, true)
    if (resultColor !== correctColor) {
        let ps = "【掉落优化】防止同色3连：(" + r + ", " + c + ") Color[" + resultColor + "] -> Color[" + correctColor + "]"
        cc.log(ps)
    }
    resultColor = correctColor
    resultColor = resultColor || preColor
    return tonumber(resultColor)
}
DAManagerV2.prototype.checkValidateColor = function (mainLogic, checkColor) {
    let self = this
    let validateColor = false
    let colorList = mainLogic.getColors()
    for (let k in colorList) {
        let v = colorList[k]
        if ($null(v)) continue
        if (v == checkColor) {
            validateColor = true
            break
        }
    }
    return validateColor
}
// 查找棋盘中最多或者最少的颜色（保留名字不变 最少颜色也在这里找）
DAManagerV2.prototype.findMostColorAfterFallingStable = function (mainLogic) {
    let self = this
    if (!self._inLevel) {
        return 
    }
    let mostColor = 0
    let leastColor = 0
    let enableFind = false
    let isPositive = true
    if (!self.generalStrongFuuuReached) {
        let isFuuuState = self.checkGeneralStrongFuuuState(mainLogic)
        if (isFuuuState) {
            self.generalStrongFuuuReached = true
            DAManagerGUILogger.getInstance().print("达到通用强FUUU状态")
        }
    }
    // 通用fuuu打点END
    if (self._currentSchemeCfg) {
        if (self._currentSchemeCfg.fuuu) {
            // fuuu干预
            // fuuu干预首先要满足3个基本条件：1. 目标完成数低于期望；2. 剩余步数大于一定步数；3. 没有达到fuuu状态
            // 202208 增加新的fuuu规则，仅在使用新计数DATargetCounterV2时使用
            let isFuuuState = self.checkFuuuState(mainLogic)
            if (!isFuuuState) {
                let count = null
                let expect = null
                let ps = null
                if (self._useDATargetCountV2) {
                    count = DATargetCounterV2.getInstance().getCurrentTargetCount()
                    expect = DATargetCounterV2.getInstance().getCurrentExpectCount()
                    ps = "【掉落优化FUUU】当前计数V2"
                } else {
                    count = DATargetCounter.getInstance().getCurrentTargetCount()
                    expect = DATargetCounter.getInstance().getCurrentExpectCount()
                    ps = "【掉落优化FUUU】当前计数V1"
                }
                // ps = ps + "\n【掉落优化FUUU】当前目标数：" + count + "，期望：" + expect + "\n期望倍率：" + self._currentSchemeCfg.fuuu.expectRatio + " 期望减少：" + self._currentSchemeCfg.fuuu.reduceExpectNum
         
                //print(ps)
                // 检查是否低于期望
                // 计数V2规则下expectRatio始终为1
                let checkExpect = false
                if (self.isBalanceScheme()) { //夹板
                    if (self._currentMostColor.least > 0) { //上一次是负向
                        //print("[newfuu] last is negative in balance")
                        checkExpect = true
                        isPositive = false
                        if (count <= expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.negative.finishReduceExpectNum) {
                            checkExpect = false
                        }
                        if (count < expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.positive.reduceExpectNum) {
                            checkExpect = true
                            isPositive = true
                        }
                        cc.log(`【test】checkExpect=${checkExpect} , isPositive=${isPositive} 上一次是负向`)
                    } else if (self._currentMostColor.most > 0) { //上一次是正向
                        //print("[newfuu] last is positive in balance")
                        checkExpect = true
                        isPositive = true
                        if (count >= expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.positive.finishReduceExpectNum) {
                            checkExpect = false
                        }
                        if (count > expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.negative.reduceExpectNum) {
                            checkExpect = true
                            isPositive = false
                        }
                        cc.log(`【test】checkExpect=${checkExpect} , isPositive=${isPositive} 上一次是正向`)
                    } else { //无上一次
                        //print("[newfuu] last is null in balance")
                        if (count > expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.negative.reduceExpectNum) {
                            checkExpect = true
                            isPositive = false
                            cc.log("【test】 ispositive false 本次负向 , 无上一次")
                        } else if (count < expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.positive.reduceExpectNum) {
                            checkExpect = true
                            isPositive = true
                            cc.log("【test】 ispositive true 本次正向 , 无上一次")
                        }
                    }
                    ps = ps + "\n【掉落优化FUUU】当前目标数：" + count + "，期望：" + expect + "\n期望倍率：" + self._currentSchemeCfg.fuuu.expectRatio
                    ps = ps + " 正向期望减少：" + self._currentSchemeCfg.positive.reduceExpectNum + " 正向期望减少结束：" + self._currentSchemeCfg.positive.finishReduceExpectNum
                    ps = ps + " 反向期望减少：" + self._currentSchemeCfg.negative.reduceExpectNum + " 反向期望减少结束：" + self._currentSchemeCfg.negative.finishReduceExpectNum
                } else if (self.isNegativeScheme()) { //负向
                    checkExpect = count > expect * self._currentSchemeCfg.fuuu.expectRatio + self._currentSchemeCfg.fuuu.reduceExpectNum
                    isPositive = false
                    cc.log("【test】 ispositive false 本次负向 ,in negative")
                    ps = ps + "\n【掉落优化FUUU】当前目标数：" + count + "，期望：" + expect + "\n期望倍率：" + self._currentSchemeCfg.fuuu.expectRatio + " 期望减少：" + self._currentSchemeCfg.fuuu.reduceExpectNum
                } else { //正向
                    cc.log("【test】 ispositive not change in positive =" + tostring(isPositive))
                    checkExpect = count < expect * self._currentSchemeCfg.fuuu.expectRatio - self._currentSchemeCfg.fuuu.reduceExpectNum
                    ps = ps + "\n【掉落优化FUUU】当前目标数：" + count + "，期望：" + expect + "\n期望倍率：" + self._currentSchemeCfg.fuuu.expectRatio + " 期望减少：" + self._currentSchemeCfg.fuuu.reduceExpectNum
                }
                if (self._lastFuuuCEStr !== ps) {
                    self._lastFuuuCEStr = ps
                    DAManagerGUILogger.getInstance().print(ps)
                }
                // 检查是否少于一定步数
                let checkEnoughStep = mainLogic.getTheCurMoves() > self._currentSchemeCfg.fuuu.stopLeftSteps
                if (checkExpect && checkEnoughStep) {
                    enableFind = true
                }
            } else if (!self.fuuuReached) {
                self.fuuuReached = true
                DAManagerGUILogger.getInstance().print("【掉落优化】已达到FUUU状态", self._useDATargetCountV2)
            }
        } else {
            // 普通干预
            // 注意，这里并不意味着最终一定干预，因为在后续tryInterveneAnimal中还有掉落口限制
            enableFind = true
        }
    }
    if (enableFind) {
        // 查找棋盘颜色最多的那个
        let counts = table()
        let $var184 = GameColor.kBlue,$limit185 = GameColor.kYellow
        for (let i = $var184; i <= $limit185; i += 1) {
            counts[i] = 0
        }
        let max = 0
        let min = 999
        let gameItemMap = GameBoardLogic.instance.gameItemMap
        let $limit190 = $len(gameItemMap)
        for (let r = 1; r <= $limit190; r += 1) {
            let $limit193 = $len(gameItemMap[r])
            for (let c = 1; c <= $limit193; c += 1) {
                let itemData = gameItemMap[r][c]
                if (itemData.itemType === GameItemType.kAnimal) {
                    let color = itemData.itemColorType || itemData.color
                    if (color && color >= GameColor.kBlue && color <= GameColor.kYellow) {
                        let v = counts[color] + 1
                        counts[color] = v
                        if (v > max) {
                            mostColor = color
                            max = v
                        }
                    }
                }
            }
        }
        if (!isPositive) {
            for (let k in counts) {
                let v = counts[k]
                if ($null(v)) continue
                if (v < min && self.checkValidateColor(mainLogic, k)) {
                    min = v
                    leastColor = k
                }
            }
        }
        if (__WIN32) {
            let str = "【掉落优化】统计棋盘中颜色："
            for (let c = 1, v = counts[1]; v || v == 0; c++, v = counts[c]) {
                str = str + "[" + c + "]: " + v + " "
            }
            str = str + "[Most]: " + mostColor
            if (!isPositive) {
                str = str + "[least]: " + leastColor
            }
            if (self._lastMostColorStr !== str) {
                self._lastMostColorStr = str
                DAManagerGUILogger.getInstance().print(str)
            }
        }
    }
    self._currentMostColor.most = 0
    self._currentMostColor.least = 0
    if (enableFind) {
        if (isPositive) {
            self._currentMostColor.most = tonumber(mostColor)
        } else {
            self._currentMostColor.least = tonumber(leastColor)
        }
    }
}
// 检查是否达到了fuuu状态
DAManagerV2.prototype.checkFuuuState = function (mainLogic, schemeCfg, useDATargetV2) {
    let self = this
    let ret = false
    schemeCfg = schemeCfg || self._currentSchemeCfg
    if (useDATargetV2 == undefined) {
        useDATargetV2 = self._useDATargetCountV2
    }
    let gameMode = mainLogic.theGamePlayType
    let stopTargetNum = schemeCfg.fuuu.stopTargetNum
    if (useDATargetV2) {
        if (self.passTargetCount === -1) {
            let fixNumCfg = schemeCfg.fuuu.reduceNum
            self.passTargetCount = DATargetCounterV2.getInstance().getPurchasePassTargetCount()
            DAManagerGUILogger.getInstance().print("【掉落优化FUUU】线上付费过关完成度 " + self.passTargetCount)
            let reduceCount = 0
            for (let k in GamePlayType) {
                let v = GamePlayType[k]
                if ($null(v)) continue
                if (v === gameMode) {
                    reduceCount = fixNumCfg[k]
                }
            }
            DAManagerGUILogger.getInstance().print("【掉落优化FUUU】需要减少 " + reduceCount)
            self.passTargetCount = self.passTargetCount - reduceCount
            DAManagerGUILogger.getInstance().print("【掉落优化FUUU】实际比较完成度 " + self.passTargetCount)
            DAManagerGUILogger.getInstance().print("【掉落优化FUUU】达成fuuu的收集物数量\n" + table.tostring(stopTargetNum))
        }
        let curCount = DATargetCounterV2.getInstance().getCurrentTargetCount()
        if (curCount > self.passTargetCount) {
            ret = self.checkFuuCommon(mainLogic, schemeCfg, useDATargetV2)
        }
    } else {
        ret = self.checkFuuCommon(mainLogic, schemeCfg, useDATargetV2)
    }
    return ret
}
//fuu干预的通用条件
DAManagerV2.prototype.checkFuuCommon = function (mainLogic, schemeCfg, useDATargetV2) {
    let self = this
    let isFuuu = false
    let gameMode = mainLogic.theGamePlayType
    schemeCfg = schemeCfg || self._currentSchemeCfg
    if (useDATargetV2 == undefined) {
        useDATargetV2 = self._useDATargetCountV2
    }
    let stopTargetNum = schemeCfg.fuuu.stopTargetNum
    if (gameMode === GamePlayType.kBoss) {
        let bossList = mainLogic.gameMode.bossList
        let leftHp = 0
        let $limit285 = $len(bossList)
        for (let i = 1; i <= $limit285; i += 1) {
            let hp = bossList[i].getCurrentHp()
            leftHp = leftHp + hp
        }
        if (useDATargetV2) {
            let lightHouseNum = mainLogic.getLightHouseNum()
            if (lightHouseNum >= leftHp) {
                // DAManagerGUILogger:getInstance():print("【掉落优化FUUU】蜂巢数量 " .. lightHouseNum .. " 剩余血量 " .. leftHp)
                isFuuu = true
            } else if (lightHouseNum === 0 && leftHp <= stopTargetNum.kBoss) {
                // DAManagerGUILogger:getInstance():print("【掉落优化FUUU】蜂巢数量 " .. lightHouseNum .. " 剩余血量 " .. leftHp)
                isFuuu = true
            }
        } else {
            isFuuu = leftHp <= stopTargetNum.kBoss
        }
    } else if (gameMode === GamePlayType.kPursue) {
        let movedSteps = mainLogic.gameMode.getFinishInfo()
        let [r, c] = mainLogic.gameMode.getItemStartRC()
        let road = mainLogic.getRoadByRC(r, c)
        if (road) {
            let leftSteps = $len(road.map) - movedSteps - 1
            if (leftSteps <= stopTargetNum.kPursue) {
                // DAManagerGUILogger:getInstance():print("【掉落优化FUUU】剩余步数 "..leftSteps)
                isFuuu = true
            }
        }
    } else {
        let ownNum = 0
        let targetNum = 0
        for (let i = 1, v = mainLogic.theOrderList[1]; v; i++, v = mainLogic.theOrderList[i]) {
            ownNum = ownNum + v.ownNum
            targetNum = targetNum + v.targetNum
        }
        let leftTarget = targetNum - ownNum
        if (gameMode === GamePlayType.kOrder && leftTarget <= stopTargetNum.kOrder) {
            isFuuu = true
        } else if (gameMode === GamePlayType.kIce && leftTarget <= stopTargetNum.kIce) {
            isFuuu = true
        } else if (gameMode === GamePlayType.kWaterDig && leftTarget <= stopTargetNum.kWaterDig) {
            isFuuu = true
        } else if (gameMode === GamePlayType.kFish && leftTarget <= stopTargetNum.kFish) {
            isFuuu = true
        } else if (gameMode === GamePlayType.kBlockCollection && leftTarget <= stopTargetNum.kBlockCollection) {
            isFuuu = true
        }
    }
    return isFuuu
}
// 被动刷新重排的次数（不包括使用道具的主动重排）
DAManagerV2.prototype.setPassiveRefreshCount = function (count) {
    let self = this
    self._passiveRefreshCount = count
    let replay = GameBoardLogic.instance.replay || ReplayManager.getInstance().getLastReplayByLevelId(self._levelId)
    if (replay) {
        replay.passiveRefreshCount = count
    }
}
DAManagerV2.prototype.getPassiveRefreshCount = function () {
    let self = this
    return self._passiveRefreshCount
}

DAManagerV2.prototype.clearAdjustStrategy = function (key) {
    let self = this
    self._strategyAdjustPlan[key] = null;
}

DAManagerV2.prototype.registAdjustStrategy = function (key, obj) {
    let self = this
    self._strategyAdjustPlan[key] = obj;
}

//设置scheme前检查下是不是注册进来了需要调整策略的 (循环取最小strategyId值)
DAManagerV2.prototype.checkAdjustStrategy = function (strategyId) {
    let self = this
    let strategyId_cur = strategyId
    for (let key in self._strategyAdjustPlan) {
        const obj = self._strategyAdjustPlan[key];
        console.log(obj);
        if (obj && obj[strategyId] != undefined) {
            if (strategyId_cur > obj[strategyId]){
                DAManagerGUILogger.getInstance().print("【掉落优化】掉落优化调整 key " +key);
                strategyId_cur = obj[strategyId]
                DAManagerGUILogger.getInstance().print("【掉落优化】掉落优化调整 " + strategyId + " -> " + strategyId_cur);
            }
        }
    }
    return strategyId_cur;
}
//------------------------
// 2025/04新增，通用fuuu打点：本关是否达到强fuuu状态（不管玩家是否有掉落干预都打）
// 检查是否达到了fuuu状态
DAManagerV2.prototype.checkGeneralStrongFuuuState = function (mainLogic) {
    let self = this
    // DAManagerGUILogger:getInstance():print("检查是否达到通用强FUUU状态")
    // WARN: maybe multi result
    return self.checkFuuuState(mainLogic, DASchemeConfig.Scheme_fuuu_strong_counterV2, true)
}
//------------------------ 通用fuuu打点 END
module.exports = DAManagerV2
